import React from 'react';
import NumberFormat from 'react-number-format';

import { ItemForm } from '../../../../components/Typography';
import { moneyConfig, percentageConfig } from '../../../../helpers/form';
import {
  formatarMoedaIMask,
  formatarPorcentagem,
} from '../../../../helpers/formatador';
import { DeleteOutlined, EditableField, FormOutlined, Texto } from './styles';

const getTextoFreteMotorista = (record, totalIndex) => {
  const { key, valor_inicial, valor_final } = record;
  const lastIndex = totalIndex - 1;

  const faixaInicial = formatarMoedaIMask(valor_inicial);
  const faixaFinal = formatarMoedaIMask(valor_final);

  let texto = <Texto>{`De ${faixaInicial} até ${faixaFinal}`}</Texto>;

  if (totalIndex === 1) {
    texto = <Texto>Qualquer valor</Texto>;
  } else if (key === lastIndex) {
    texto = <Texto>{`Acima de ${faixaInicial}`}</Texto>;
  }

  return texto;
};

export const columns = (
  tarifasLength,
  editingKey,
  inputTarifa,
  deletarFaixaDeValor,
  saveValue,
  startEditing,
  keyPressed
) => [
  {
    title: 'Frete motorista',
    dataIndex: 'valor_inicial',
    key: 'valor_inicial',
    align: 'center',
    render: (_, record) => getTextoFreteMotorista(record, tarifasLength),
  },
  {
    title: 'Valor por tonelada',
    dataIndex: 'valorPorTonelada',
    key: 'valorPorTonelada',
    align: 'center',
    render: (
      _,
      { key, valor_tarifa_percentual, valor_tarifa_reais_tonelada }
    ) => {
      const numberFormatConfig = inputTarifa ? percentageConfig : moneyConfig;
      const valorTarifa = inputTarifa
        ? valor_tarifa_percentual
        : valor_tarifa_reais_tonelada;
      const tarifaFormatada = inputTarifa
        ? formatarPorcentagem(valor_tarifa_percentual)
        : formatarMoedaIMask(valor_tarifa_reais_tonelada);

      return (
        <>
          {editingKey === key ? (
            <ItemForm name="editingField">
              <NumberFormat
                autoFocus
                onBlur={saveValue}
                onKeyPress={keyPressed}
                {...numberFormatConfig}
              />
            </ItemForm>
          ) : (
            <EditableField>
              <Texto>{tarifaFormatada}</Texto>

              <FormOutlined onClick={() => startEditing(key, valorTarifa)} />

              {key === tarifasLength - 1 && (
                <DeleteOutlined onClick={deletarFaixaDeValor} />
              )}
            </EditableField>
          )}
        </>
      );
    },
  },
];
